"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollsGraphQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
const downloadRegistry_1 = __importDefault(require("./mutations/downloadRegistry"));
class PollsGraphQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getPolls = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.listPolls, variables, options, requestOptions);
      return response.data.polls.listPolls;
    });
    this.getTemplates = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.templates, variables, options, requestOptions);
      return response.data.polls.templates;
    });
    this.getPollStatuses = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.listPollStatuses, variables, options, requestOptions);
      return response.data.polls.listPolls;
    });
    this.getPollVoteResults = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.aggregatedVoting, variables, options, requestOptions);
      return response.data.polls.aggregatedVoting;
    });
    this.getQuestionDetailedVoteResults = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.detailedVoting, variables, options, requestOptions);
      return response.data.polls.detailedVoting;
    });
    this.getPollMyVoting = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.myVoting, variables, options, requestOptions);
      return response.data.polls.myVoting;
    });
    this.getPollHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.history, variables, options, requestOptions);
      return response.data.polls.history;
    });
    this.getPollPublishedResultsLink = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.exportResultsOfPoll, variables, options, requestOptions);
      return response.data.polls.exportResultsOfPoll;
    });
    this.createPoll = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.createPoll, variables, options, requestOptions);
      return response.data.polls.createPoll;
    });
    this.createPollFromTemplate = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.createPollFromTemplate, variables, options, requestOptions);
      return response.data.polls.createPollFromTemplate;
    });
    this.updatePollFromTemplate = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.updatePollFromTemplate, variables, options, requestOptions);
      return response.data.polls.updatePollFromTemplate;
    });
    this.updatePoll = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.updatePoll, variables, options, requestOptions);
      return response.data.polls.updatePoll;
    });
    this.deletePoll = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deletePoll, variables, options, requestOptions);
      return response.data.polls.deletePoll;
    });
    this.copyPoll = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.copyPoll, variables, options, requestOptions);
      return response.data.polls.copyPoll;
    });
    this.setPollStatus = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.setPollStatus, variables, options, requestOptions);
      return response.data.polls.setStatusPoll;
    });
    this.updatePollFinishDate = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.updatePollDateFinished, variables, options, requestOptions);
      return response.data.polls.updatePollDateFinished;
    });
    this.addPollAttachments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.addPollAttachments, variables, options, requestOptions);
      return response.data.polls.addPollAttachments;
    });
    this.deletePollAttachment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deletePollAttachment, variables, options, requestOptions);
      return response.data.polls.deletePollAttachment;
    });
    this.addPollCover = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.addPollCover, variables, options, requestOptions);
      return response.data.polls.addPollCover;
    });
    this.createPollQuestion = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.createPollQuestion, variables, options, requestOptions);
      return response.data.polls.createPollQuestion;
    });
    this.updatePollQuestion = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.updatePollQuestion, variables, options, requestOptions);
      return response.data.polls.updatePollQuestion;
    });
    this.deletePollQuestion = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deletePollQuestion, variables, options, requestOptions);
      return response.data.polls.deletePollQuestion;
    });
    this.addPollQuestionAnswer = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.addPollQuestionItem, variables, options, requestOptions);
      return response.data.polls.addPollQuestionItem;
    });
    this.updatePollQuestionAnswer = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.updatePollQuestionItem, variables, options, requestOptions);
      return response.data.polls.updatePollQuestionItem;
    });
    this.deletePollQuestionAnswer = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deletePollQuestionItem, variables, options, requestOptions);
      return response.data.polls.deletePollQuestionItem;
    });
    this.addQuestionAttachments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.addQuestionAttachments, variables, options, requestOptions);
      return response.data.polls.addQuestionAttachments;
    });
    this.deleteQuestionAttachment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.deleteQuestionAttachment, variables, options, requestOptions);
      return response.data.polls.deleteQuestionAttachment;
    });
    this.vote = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.vote, variables, options, requestOptions);
      return response.data.polls.vote;
    });
    this.downloadPollRegistry = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(downloadRegistry_1.default, variables, options, requestOptions);
      return response.data.polls.votingRegistry;
    });
    this.getFilters = (variables = {}, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.poolsFilters, variables, options, requestOptions);
      return response.data.polls.pollsFilters;
    });
  }
}
exports.PollsGraphQLService = PollsGraphQLService;
const pollsGraphQLService = new PollsGraphQLService();
exports.default = pollsGraphQLService;